// extracted by mini-css-extract-plugin
export default {"hubName":"PathwayUIntegration_hubName__2TlVW","hubIdentifier":"PathwayUIntegration_hubIdentifier__4O6Zz"};